<template>
  <tr>
    <td class="text-center">
      <span class="form-control form-control-plaintext">{{
        rowIndex + 1
      }}</span>
    </td>
    <!-- ประเภทสินค้า-->
    <td class="form-group">
      <select2
        :css-style="'width: 100%;'"
        :css-class="'form-control required'"
        :id="'productCode' + _uid"
        :name="'productCode' + _uid"
        :select2-options="productCodeOptions"
        :disabled="item.isDisableProduct"
        v-model="item.productCode"
        ref="productCode"
        data-msg-required="กรุณาเลือกสินค้า"
      ></select2>
      <span class="form-text"></span>
    </td>
    <!-- ประเภทสินค้า-->
    <!-- ต้นทุนสินค้า(บาท)	-->
    <td class="form-group">
      <currency-input
        class="form-control required text-right"
        :id="'productCost' + _uid"
        :name="'productCost' + _uid"
        v-model="item.productCost"
        v-currency="{ locale, currency }"
        auto-decimal-mode:true
        placeholder="ราคา"
        data-msg-required="กรุณากรอกจำนวน"
      />
      <span class="form-text"></span>
    </td>
    <!-- ต้นทุนสินค้า(บาท)	-->
    <template v-for="monthIndex in 12">
      <td v-for="dataIndex in 5" :key="monthIndex + '-' + dataIndex">
          <currency-input class="form-control text-right"
                          v-currency="{locale: 'th',currency: null,precision: dataIndex === 5 ? 2 : 0}"
                          v-model="item.data[monthIndex - 1]['data' + dataIndex]"
                          auto-decimal-mode:true
                          data-msg-required="กรุณากรอกจำนวน"
                          v-on:keyup="calculateTotalValue(item, monthIndex)"
                          :readonly="(dataIndex === 4 || dataIndex === 5) ||
                          (yearSelected == currentYear && monthIndex > currentMonth) ||
                          (item.isDisableRow)"
              />
</td>
    </template>
    <td class="form-group">
      <currency-input
        readonly
        class="form-control  text-right"
        :id="'totalData1' + _uid"
        :name="'totalData1' + _uid"
        :value="ChecktotalCostAll(_uid,1)"
        v-currency="{ locale: 'th',currency: null,precision: 0 }"
        auto-decimal-mode:true
      />
    </td>
    <td class="form-group">
      <currency-input
        readonly
        class="form-control  text-right"
        :id="'totalData2' + _uid"
        :name="'totalData2' + _uid"
        :value="ChecktotalCostAll(_uid,2)"
        v-currency="{ locale: 'th',currency: null,precision: 0 }"
        auto-decimal-mode:true
      />
    </td>
    <td class="form-group">
      <currency-input
        readonly
        class="form-control  text-right"
        :id="'totalData3' + _uid"
        :name="'totalData3' + _uid"
        :value="ChecktotalCostAll(_uid,3)"
        v-currency="{ locale: 'th',currency: null,precision: 0 }"
        auto-decimal-mode:true
      />
    </td>
    <td class="form-group">
      <currency-input
        readonly
        class="form-control  text-right"
        :id="'totalRemain' + _uid"
        :name="'totalRemain' + _uid"
        :value="(ChecktotalCostAll(_uid, 1) + ChecktotalCostAll(_uid, 2)) - ChecktotalCostAll(_uid, 3)"
        v-currency="{ locale: 'th',currency: null,precision: 0 }"
        auto-decimal-mode:true
      />
    </td>
    <td class="form-group">
      <currency-input
        readonly
        class="form-control  text-right"
        :id="'totalpercent' + _uid"
        :name="'totalpercent' + _uid"
        :value="calTotalPercent(_uid) || 0.00"
        v-currency="{ locale: 'th',currency: null,precision: 2 }"
        auto-decimal-mode:true
      />
    </td>
    <!-- จัดการ -->
    <td class="form-group">
      <center>
        <button
          type="button"
          class="btn btn-outline-hover-danger btn-elevate btn-circle btn-icon"
          @click.prevent="onRemoveItemClick"
          v-if="!item.isDisableProduct"
        >
          <i class="text-danger la la-trash"></i>
        </button>
      </center>
    </td>
  </tr>
</template>

<script>
import axios from "axios";
import select2 from "../../../Shared/Select2";

export default {
  components: {
    select2,
  },
  props: {
    rowIndex: Number,
    item: {
      type: Object,
      required: true,
    },
    kPIProductType: {
      type: String,
      required: true
    },
    yearSelected: {
      type: Number 
      }
  },
  data() {
    var self = this;
    var date = new Date();
    var monthNo = date.getMonth() + 1;
    var yearNo = date.getFullYear();
    return {
      currentYear: new Date().getFullYear(),
      currentMonth: new Date().getMonth() + 1,
      currency: "THB",
      locale: "th",
      productCodeOptions: {
        placeholder: "กรุณาเลือกสินค้า",
        allowClear: true,
        ajax: {
          delay: 300,
          url: "/Api/Product/Select2Product",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              productTypeOption: self.kPIProductType
            };
            return query;
          },
          processResults: function(data, params) {
            if (self.item.listProductCode != null) {
              data.results = data.results.filter(
                (o) => !self.item.listProductCode.includes(o.id)
              );
            }
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
    };
  },
  methods: {
    ChecktotalCostAll(_uid,dataIndex) {
      let total = 0;
      for (let monthIndex = 1; monthIndex <= 12; monthIndex++) {
        total += this.item.data[monthIndex - 1]['data' + dataIndex];
      }
      return total;
    },
    calTotalPercent(_uid) {
      const totalData1 = this.ChecktotalCostAll(_uid, 1);
      const totalData2 = this.ChecktotalCostAll(_uid, 2);
      const totalData3 = this.ChecktotalCostAll(_uid, 3);
      if (totalData1 == 0 && totalData2 == 0) {
        return 0;
      }
      var totalPercent = ((totalData3 / (totalData1 + totalData2)) * 100).toFixed(2)
      if (totalPercent == Number.POSITIVE_INFINITY || totalPercent == Number.NEGATIVE_INFINITY || isNaN(totalPercent)) {
        totalPercent = '0.00';
      }
      return parseFloat(totalPercent);
    },
    onRemoveItemClick(e) {
      this.$emit("removeItem", this.rowIndex, this.item)
    },
    calculateTotalValue(item, monthIndex) {
      const monthData = item.data[monthIndex - 1];
      const val1 = parseInt(monthData.data1) || 0;
      const val2 = parseInt(monthData.data2) || 0;
      const val3 = parseInt(monthData.data3) || 0;
      const val4 = (val1 + val2) - val3;
      let val5 = ((val3 / (val1 + val2)) * 100).toFixed(2);
      if (val5 == Number.POSITIVE_INFINITY || val5 == Number.NEGATIVE_INFINITY || isNaN(val5)) {
        val5 = '0.00';
      }
      this.$set(item.data[monthIndex - 1], 'data4', val4);
      this.$set(item.data[monthIndex - 1], 'data5', parseFloat(val5));
    },
  },
async mounted() {
    $(".required", this.$el).each(function() {
      const $input = $(this);
      $input.rules("add", {
        required: true,
        messages: {
          required: $input.data("msg-required"),
        },
      });
    });

    
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/KPI/Products/ProductItemCalRow.vue